/* Phase B1 link and progress widgets: GA4 events without cart mutations. */
(() => {
  if (window.npmAnalyticsInitialized) return;
  window.npmAnalyticsInitialized = true;

  const selector = '[data-npm-widget]';
  const discovered = new WeakSet();
  const viewedKeys = new Set();
  const pendingViews = new Map();
  let retryScheduled = false;
  const params = (element) => {
    const page = document.body?.dataset || document.documentElement.dataset || {};
    return {
      widget_type: element.dataset.npmWidget || '',
      widget_id: element.dataset.npmWidgetId || '',
      widget_target: element.dataset.npmTarget || '',
      page_product: element.dataset.npmPageProduct ?? page.npmPageProduct ?? '',
      page_type: element.dataset.npmPageType ?? page.npmPageType ?? '',
    };
  };
  const stableKey = (element) => {
    const data = params(element);
    return [data.page_type, data.page_product, data.widget_type, data.widget_id, data.widget_target].join('|');
  };
  const send = (name, element) => {
    const data = params(element);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, data);
        return true;
      }
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
        return true;
      }
      return false;
    } catch {
      // A tracker failure must never interrupt navigation or cart rendering.
      return false;
    }
  };
  const scheduleRetry = () => {
    if (retryScheduled || pendingViews.size === 0) return;
    retryScheduled = true;
    setTimeout(() => {
      retryScheduled = false;
      flushPending();
    }, 250);
  };
  const flushPending = () => {
    pendingViews.forEach((element, key) => {
      if (!element.isConnected) {
        pendingViews.delete(key);
        return;
      }
      if (send('npm_widget_view', element)) {
        viewedKeys.add(key);
        pendingViews.delete(key);
        observer?.unobserve(element);
      }
    });
    scheduleRetry();
  };
  const view = (element) => {
    const key = stableKey(element);
    if (viewedKeys.has(key)) return true;
    pendingViews.set(key, element);
    flushPending();
    return viewedKeys.has(key);
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || !entry.target.isConnected) return;
          if (view(entry.target)) observer.unobserve(entry.target);
        });
      })
    : null;
  const discover = (element) => {
    if (discovered.has(element)) return;
    discovered.add(element);
    if (observer) observer.observe(element);
    else view(element);
  };
  const scan = (root) => {
    if (root.matches?.(selector)) discover(root);
    root.querySelectorAll?.(selector).forEach(discover);
  };
  const unobserve = (root) => {
    if (!observer) return;
    if (root.matches?.(selector)) observer.unobserve(root);
    root.querySelectorAll?.(selector).forEach((element) => observer.unobserve(element));
  };
  scan(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === 1 && !node.isConnected) unobserve(node);
      });
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('load', flushPending, { once: true });

  document.addEventListener('click', (event) => {
    const element = event.target.closest?.(selector);
    if (element) send('npm_widget_click', element);
  }, true);
})();
